import type {
    AttributeDeviceGroupPayload,
    AttributeDeviceGroupResponse,
} from '@/types/apps/attribute-device-group.type';

import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

export interface AttributeDeviceGroupServiceInterface {}

type AttributeDeviceGroupListResponse = ApiResponse<
    PaginatedResult<AttributeDeviceGroupResponse>
>;
type AttributeDeviceGroupDetailResponse =
    ApiResponse<AttributeDeviceGroupResponse>;

export class AttributeDeviceGroupService
    implements Indexable, Showable, Creatable, Updatable, Deletable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/attribute-device-group',
        detail: (id: string) => `/api/attribute-device-group/${id}`,
    };

    public index(
        params?: QueryParams
    ): Promise<AttributeDeviceGroupListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<AttributeDeviceGroupDetailResponse> {
        return this.apiClient.fetchApi<AttributeDeviceGroupResponse>(
            this.endpoints.detail(id),
            params
        );
    }

    public create(
        payload: AttributeDeviceGroupPayload
    ): Promise<ApiResponse<AttributeDeviceGroupResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: AttributeDeviceGroupPayload
    ): Promise<ApiResponse<AttributeDeviceGroupResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }

    public destroy(ids: string[], isHardDeleted?: boolean): Promise<any> {
        return this.apiClient.destroyApi<void>(
            this.endpoints.base(),
            ids,
            isHardDeleted
        );
    }
}
